import React from 'react'
import {
  ContainerPricingModel,
  Product,
} from '../../../../modules/productsListing/types'
import { FormikProps, useFormikContext } from 'formik'
import { PrivateOffer } from '../../../../modules/privateOffer/types'
import { BoxV4 } from '@labrav/react-components'
import { Typography } from '@mui/material'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShelves } from '@fortawesome/pro-regular-svg-icons'
import { ContractPricingTermV2 } from '../../../PrivateOfferComponents/ContractPricingTerm/ContractPricingTermV2'
import { useStyles } from './PrivateOfferContractPricingTerm.styles'

export type PrivateOfferContractPricingTermProps = {
  product: Product
}
export const PrivateOfferContractPricingTerm: React.FC<
  PrivateOfferContractPricingTermProps
> = ({ product }) => {
  const { values } = useFormikContext() as FormikProps<PrivateOffer>
  const formikProps = useFormikContext() as FormikProps<PrivateOffer>
  const { classes } = useStyles()
  return (
    <div data-testid="contract-pricing-term">
      <BoxV4
        heading={`${
          product.containerPricingModel === ContainerPricingModel.HOURLY &&
          values.flexiblePaymentTerms
            ? 'Product dimensions'
            : 'Contract pricing terms'
        }`}
        headingIcon={
          <FontAwesomeIcon
            icon={faShelves}
            style={{ width: '18px', height: '14px' }}
          />
        }
      >
        {/* product dimenions */}
        <div className={classes.sectionContainer}>
          <div className={classes.textContainer}>
            <Typography className={classes.sectionText}>
              {product.containerPricingModel === ContainerPricingModel.HOURLY &&
              values.flexiblePaymentTerms
                ? 'Customize the units for your listing.'
                : `Customize the prices or units for: ${product.productName}`}
            </Typography>
          </div>
          <ContractPricingTermV2
            formik={
              formikProps as unknown as FormikProps<Record<string, unknown>>
            }
            productId={product?.productId}
          />
        </div>
      </BoxV4>
    </div>
  )
}
